export default class FormManagerProxy {
  constructor(manager) {
    this._manager = manager;
  }

  validate({ name, value, rules }) {
    this._manager.validate({ name, value, rules });
  }

  setVisibility(mode = 'view') {
    this._manager.setVisibility(mode);
  }

  resetFormState() {
    this._manager.resetFormState();
  }

  isFormFilledOK() {
    return this._manager.isFormFilledOK();
  }

  setControlVisibility(controlName, mode) {
    this._manager.setControlVisibility(controlName, mode);
  }

  disableControl(controlName) {
    this._manager.disableControl(controlName);
  }

  enableControl(controlName) {
    this._manager.enableControl(controlName);
  }

  setControlAsInvalid(controlName, message) {
    this._manager.setControlAsInvalid(controlName, message);
  }

  setControlAsValid(controlName) {
    this._manager.setControlAsValid(controlName);
  }

  isValid() {
    return this._manager.isValid();
  }

  getData() {
    return this._manager.getData();
  }

  setFormMode(mode) {
    this._manager.setFormMode(mode);
  }

  setControllerState(name, value) {
    this._manager.setControllerState(name, value);
  }
}
